import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useSite } from "@/lib/site";

export const WhatsAppButton = () => {
  const site = useSite();
  const { pathname } = useLocation();
  const number = (site.whatsapp || "").replace(/\D/g, "");
  if (!number) return null;
  const onVehicle = /^\/stock\/(?!sold$)[^/]+$/.test(pathname);
  return (
    <a href={`https://wa.me/${number}`} target="_blank" rel="noreferrer" aria-label="Message us on WhatsApp" data-testid="floating-whatsapp"
      className={`group fixed right-4 z-[60] flex h-14 w-14 items-center justify-center rounded-full bg-forest text-paper shadow-[0_12px_30px_-10px_rgba(22,53,44,.6)] transition-transform duration-300 hover:scale-105 sm:right-6 ${onVehicle ? "bottom-20 lg:bottom-6" : "bottom-4 sm:bottom-6"}`}>
      <MessageCircle className="h-6 w-6" strokeWidth={1.6} />
      <span className="pointer-events-none absolute right-16 hidden whitespace-nowrap bg-charcoal px-3 py-1.5 text-xs text-paper opacity-0 transition-opacity duration-300 group-hover:opacity-100 lg:block">Message us on WhatsApp</span>
    </a>
  );
};
